import { __decorate, __param } from 'tslib';
import { Optional, Self, Inject, ChangeDetectorRef, ViewChild, Input, HostBinding, Component, ChangeDetectionStrategy, forwardRef, NgModule } from '@angular/core';
import { NgControl, FormsModule } from '@angular/forms';
import { AbstractTuiNullableControl, TUI_DEFAULT_IDENTITY_MATCHER, tuiDefaultProp, TUI_FOCUSABLE_ITEM_ACCESSOR, TuiHoveredModule, TuiPressedModule } from '@taiga-ui/cdk';
import { TuiModeDirective, TuiWrapperModule } from '@taiga-ui/core';
import { TuiRadioComponent, TuiRadioModule } from '@taiga-ui/kit/components/radio';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/cdk';
import * as ɵngcc2 from '@taiga-ui/core';
import * as ɵngcc3 from '@taiga-ui/kit/components/radio';
import * as ɵngcc4 from '@angular/forms';

const _c0 = ["*"];
var TuiRadioBlockComponent_1;
let TuiRadioBlockComponent = TuiRadioBlockComponent_1 = class TuiRadioBlockComponent extends AbstractTuiNullableControl {
    constructor(control, changeDetectorRef, modeDirective) {
        super(control, changeDetectorRef);
        this.modeDirective = modeDirective;
        this.identityMatcher = TUI_DEFAULT_IDENTITY_MATCHER;
        this.contentAlign = 'right';
        this.size = 'l';
        this.hideRadio = false;
        this.pseudoDisabled = false;
    }
    get nativeFocusableElement() {
        return this.radio ? this.radio.nativeFocusableElement : null;
    }
    get focused() {
        return !!this.radio && this.radio.focused;
    }
    get computedDisabled() {
        return this.disabled || this.pseudoDisabled;
    }
    get checked() {
        return this.value === this.item && this.hideRadio;
    }
    get checkboxSize() {
        return this.size === 'l' ? 'l' : 'm';
    }
    get appearance() {
        if (!this.modeDirective || !this.modeDirective.mode) {
            return this.checked
                ? "whiteblock-active" /* WhiteblockActive */
                : "whiteblock" /* Whiteblock */;
        }
        return this.checked ? "primary" /* Primary */ : "secondary" /* Secondary */;
    }
    onFocused(focused) {
        this.updateFocused(focused);
    }
    onHovered(hovered) {
        this.updateHovered(hovered);
    }
    onPressed(pressed) {
        this.updatePressed(pressed);
    }
    onFocusVisible(focusVisible) {
        this.updateFocusVisible(focusVisible);
    }
    onModelChange(value) {
        this.updateValue(value);
    }
};
TuiRadioBlockComponent.ɵfac = function TuiRadioBlockComponent_Factory(t) { return new (t || TuiRadioBlockComponent)(ɵngcc0.ɵɵdirectiveInject(NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(TuiModeDirective, 8)); };
TuiRadioBlockComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiRadioBlockComponent, selectors: [["tui-radio-block"]], viewQuery: function TuiRadioBlockComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TuiRadioComponent, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.radio = _t.first);
    } }, hostVars: 8, hostBindings: function TuiRadioBlockComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-tui-host-align", ctx.contentAlign)("data-size", ctx.size);
        ɵngcc0.ɵɵclassProp("_hidden_radio", ctx.hideRadio)("_disabled", ctx.computedDisabled)("_active", ctx.checked);
    } }, inputs: { identityMatcher: "identityMatcher", contentAlign: "contentAlign", size: "size", hideRadio: "hideRadio", pseudoDisabled: "pseudoDisabled", item: "item" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                useExisting: forwardRef(() => TuiRadioBlockComponent_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c0, decls: 7, vars: 19, consts: [[1, "wrapper", 3, "tuiHoveredChange", "tuiPressedChange"], [3, "appearance", "disabled", "focused", "hovered", "pressed", "invalid"], [1, "content-wrapper"], [1, "content"], [1, "view", 3, "focusable", "identityMatcher", "item", "name", "nativeId", "readOnly", "pseudoDisabled", "pseudoInvalid", "pseudoFocused", "pseudoHovered", "pseudoPressed", "size", "ngModel", "ngModelChange", "focusedChange", "focusVisibleChange"], [1, "label"]], template: function TuiRadioBlockComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵlistener("tuiHoveredChange", function TuiRadioBlockComponent_Template_label_tuiHoveredChange_0_listener($event) { return ctx.onHovered($event); })("tuiPressedChange", function TuiRadioBlockComponent_Template_label_tuiPressedChange_0_listener($event) { return ctx.onPressed($event); });
        ɵngcc0.ɵɵelementStart(1, "tui-wrapper", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "tui-radio", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function TuiRadioBlockComponent_Template_tui_radio_ngModelChange_4_listener($event) { return ctx.onModelChange($event); })("focusedChange", function TuiRadioBlockComponent_Template_tui_radio_focusedChange_4_listener($event) { return ctx.onFocused($event); })("focusVisibleChange", function TuiRadioBlockComponent_Template_tui_radio_focusVisibleChange_4_listener($event) { return ctx.onFocusVisible($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("appearance", ctx.appearance)("disabled", ctx.computedDisabled)("focused", ctx.computedFocusVisible)("hovered", ctx.computedHovered)("pressed", ctx.computedPressed)("invalid", ctx.computedInvalid);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("focusable", ctx.focusable)("identityMatcher", ctx.identityMatcher)("item", ctx.item)("name", ctx.computedName)("nativeId", ctx.nativeId)("readOnly", ctx.readOnly)("pseudoDisabled", ctx.computedDisabled)("pseudoInvalid", ctx.computedInvalid)("pseudoFocused", false)("pseudoHovered", ctx.computedHovered)("pseudoPressed", ctx.computedPressed)("size", ctx.checkboxSize)("ngModel", ctx.value);
    } }, directives: [ɵngcc1.TuiHoveredDirective, ɵngcc1.TuiPressedDirective, ɵngcc2.TuiWrapperDirective, ɵngcc3.TuiRadioComponent, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], styles: ["[_nghost-%COMP%]{font:var(--tui-font-text-s);color:var(--tui-text-01);display:inline-block;vertical-align:top;border-radius:var(--tui-radius-m)}[data-size='l'][_nghost-%COMP%], [data-size='m'][_nghost-%COMP%]{font:var(--tui-font-text-m)}._readonly[_nghost-%COMP%]{pointer-events:none}.wrapper[_ngcontent-%COMP%]{position:relative;border-radius:inherit;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._disabled[_nghost-%COMP%]   .wrapper[_ngcontent-%COMP%]{cursor:default}.content-wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column}[data-size='s'][_nghost-%COMP%]   .content-wrapper[_ngcontent-%COMP%]{min-height:var(--tui-height-s)}[data-size='m'][_nghost-%COMP%]   .content-wrapper[_ngcontent-%COMP%]{min-height:var(--tui-height-m)}[data-size='l'][_nghost-%COMP%]   .content-wrapper[_ngcontent-%COMP%]{min-height:var(--tui-height-l)}.content[_ngcontent-%COMP%]{display:flex;align-items:center;min-height:inherit}[data-tui-host-align=right][_nghost-%COMP%]   .content[_ngcontent-%COMP%]{flex-direction:row-reverse}[data-size='s'][_nghost-%COMP%]   .content[_ngcontent-%COMP%]{padding:0 1rem 0 .5rem}[data-size='s'][data-tui-host-align=right][_nghost-%COMP%]   .content[_ngcontent-%COMP%]{padding:0 .5rem 0 1rem}[data-size='s']._hidden_radio[_nghost-%COMP%]   .content[_ngcontent-%COMP%]{padding:0 1rem}[data-size='m'][_nghost-%COMP%]   .content[_ngcontent-%COMP%]{padding:0 1rem 0 .75rem}[data-size='m'][data-tui-host-align=right][_nghost-%COMP%]   .content[_ngcontent-%COMP%]{padding:0 .75rem 0 1rem}[data-size='m']._hidden_radio[_nghost-%COMP%]   .content[_ngcontent-%COMP%]{padding:0 1.5rem}[data-size='l'][_nghost-%COMP%]   .content[_ngcontent-%COMP%]{padding:0 1rem}[data-size='l']._hidden_radio[_nghost-%COMP%]   .content[_ngcontent-%COMP%]{padding:0 2.25rem}.view[_ngcontent-%COMP%]{margin-top:.75rem;margin-right:.75rem;align-self:flex-start}[data-tui-host-align=right][_nghost-%COMP%]   .view[_ngcontent-%COMP%]{margin-left:.75rem;margin-right:0}[data-size='s'][_nghost-%COMP%]   .view[_ngcontent-%COMP%]{margin-top:.5rem;margin-right:.5rem}[data-size='s'][data-tui-host-align=right][_nghost-%COMP%]   .view[_ngcontent-%COMP%]{margin-left:.5rem}[data-size='m'][_nghost-%COMP%]   .view[_ngcontent-%COMP%]{margin-top:.875rem}[data-size='l'][_nghost-%COMP%]   .view[_ngcontent-%COMP%]{margin-top:1rem}[data-size='l'][data-tui-host-align=right][_nghost-%COMP%]   .view[_ngcontent-%COMP%]{margin-left:1rem;margin-right:0}._hidden_radio[_nghost-%COMP%]   .view[_ngcontent-%COMP%]{position:absolute;height:1px;width:1px;margin:-1px;border:0;padding:0;overflow:hidden;clip:rect(0,0,0,0);-webkit-clip-path:inset(0);clip-path:inset(0)}.label[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex-grow:1}._hidden_radio[_nghost-%COMP%]   .label[_ngcontent-%COMP%]{text-align:center}"], changeDetection: 0 });
TuiRadioBlockComponent.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NgControl,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] },
    { type: TuiModeDirective, decorators: [{ type: Optional }, { type: Inject, args: [TuiModeDirective,] }] }
];
__decorate([
    ViewChild(TuiRadioComponent)
], TuiRadioBlockComponent.prototype, "radio", void 0);
__decorate([
    Input()
], TuiRadioBlockComponent.prototype, "item", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiRadioBlockComponent.prototype, "identityMatcher", void 0);
__decorate([
    Input(),
    HostBinding('attr.data-tui-host-align'),
    tuiDefaultProp()
], TuiRadioBlockComponent.prototype, "contentAlign", void 0);
__decorate([
    Input(),
    HostBinding('attr.data-size'),
    tuiDefaultProp()
], TuiRadioBlockComponent.prototype, "size", void 0);
__decorate([
    Input(),
    HostBinding('class._hidden_radio'),
    tuiDefaultProp()
], TuiRadioBlockComponent.prototype, "hideRadio", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiRadioBlockComponent.prototype, "pseudoDisabled", void 0);
__decorate([
    HostBinding('class._disabled')
], TuiRadioBlockComponent.prototype, "computedDisabled", null);
__decorate([
    HostBinding('class._active')
], TuiRadioBlockComponent.prototype, "checked", null);
TuiRadioBlockComponent = TuiRadioBlockComponent_1 = __decorate([ __param(0, Optional()),
    __param(0, Self()),
    __param(0, Inject(NgControl)),
    __param(1, Inject(ChangeDetectorRef)),
    __param(2, Optional()),
    __param(2, Inject(TuiModeDirective))
], TuiRadioBlockComponent);

let TuiRadioBlockModule = class TuiRadioBlockModule {
};
TuiRadioBlockModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiRadioBlockModule });
TuiRadioBlockModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiRadioBlockModule_Factory(t) { return new (t || TuiRadioBlockModule)(); }, imports: [[
            FormsModule,
            TuiHoveredModule,
            TuiPressedModule,
            TuiRadioModule,
            TuiWrapperModule,
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiRadioBlockComponent, [{
        type: Component,
        args: [{
                selector: 'tui-radio-block',
                template: "<label\n    class=\"wrapper\"\n    (tuiHoveredChange)=\"onHovered($event)\"\n    (tuiPressedChange)=\"onPressed($event)\"\n>\n    <tui-wrapper\n        [appearance]=\"appearance\"\n        [disabled]=\"computedDisabled\"\n        [focused]=\"computedFocusVisible\"\n        [hovered]=\"computedHovered\"\n        [pressed]=\"computedPressed\"\n        [invalid]=\"computedInvalid\"\n    >\n        <div class=\"content-wrapper\">\n            <div class=\"content\">\n                <tui-radio\n                    class=\"view\"\n                    [focusable]=\"focusable\"\n                    [identityMatcher]=\"identityMatcher\"\n                    [item]=\"item\"\n                    [name]=\"computedName\"\n                    [nativeId]=\"nativeId\"\n                    [readOnly]=\"readOnly\"\n                    [pseudoDisabled]=\"computedDisabled\"\n                    [pseudoInvalid]=\"computedInvalid\"\n                    [pseudoFocused]=\"false\"\n                    [pseudoHovered]=\"computedHovered\"\n                    [pseudoPressed]=\"computedPressed\"\n                    [size]=\"checkboxSize\"\n                    [ngModel]=\"value\"\n                    (ngModelChange)=\"onModelChange($event)\"\n                    (focusedChange)=\"onFocused($event)\"\n                    (focusVisibleChange)=\"onFocusVisible($event)\"\n                ></tui-radio>\n                <div class=\"label\">\n                    <ng-content></ng-content>\n                </div>\n            </div>\n        </div>\n    </tui-wrapper>\n</label>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                        useExisting: forwardRef(() => TuiRadioBlockComponent_1)
                    },
                ],
                styles: [":host{font:var(--tui-font-text-s);color:var(--tui-text-01);display:inline-block;vertical-align:top;border-radius:var(--tui-radius-m)}:host[data-size='l'],:host[data-size='m']{font:var(--tui-font-text-m)}:host._readonly{pointer-events:none}.wrapper{position:relative;border-radius:inherit;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}:host._disabled .wrapper{cursor:default}.content-wrapper{display:flex;flex-direction:column}:host[data-size='s'] .content-wrapper{min-height:var(--tui-height-s)}:host[data-size='m'] .content-wrapper{min-height:var(--tui-height-m)}:host[data-size='l'] .content-wrapper{min-height:var(--tui-height-l)}.content{display:flex;align-items:center;min-height:inherit}:host[data-tui-host-align=right] .content{flex-direction:row-reverse}:host[data-size='s'] .content{padding:0 1rem 0 .5rem}:host[data-size='s'][data-tui-host-align=right] .content{padding:0 .5rem 0 1rem}:host[data-size='s']._hidden_radio .content{padding:0 1rem}:host[data-size='m'] .content{padding:0 1rem 0 .75rem}:host[data-size='m'][data-tui-host-align=right] .content{padding:0 .75rem 0 1rem}:host[data-size='m']._hidden_radio .content{padding:0 1.5rem}:host[data-size='l'] .content{padding:0 1rem}:host[data-size='l']._hidden_radio .content{padding:0 2.25rem}.view{margin-top:.75rem;margin-right:.75rem;align-self:flex-start}:host[data-tui-host-align=right] .view{margin-left:.75rem;margin-right:0}:host[data-size='s'] .view{margin-top:.5rem;margin-right:.5rem}:host[data-size='s'][data-tui-host-align=right] .view{margin-left:.5rem}:host[data-size='m'] .view{margin-top:.875rem}:host[data-size='l'] .view{margin-top:1rem}:host[data-size='l'][data-tui-host-align=right] .view{margin-left:1rem;margin-right:0}:host._hidden_radio .view{position:absolute;height:1px;width:1px;margin:-1px;border:0;padding:0;overflow:hidden;clip:rect(0,0,0,0);-webkit-clip-path:inset(0);clip-path:inset(0)}.label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex-grow:1}:host._hidden_radio .label{text-align:center}"]
            }]
    }], function () { return [{ type: ɵngcc4.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }, {
                type: Inject,
                args: [NgControl]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }, { type: ɵngcc2.TuiModeDirective, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [TuiModeDirective]
            }] }]; }, { identityMatcher: [{
            type: Input
        }], contentAlign: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-tui-host-align']
        }], size: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.data-size']
        }], hideRadio: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class._hidden_radio']
        }], pseudoDisabled: [{
            type: Input
        }], computedDisabled: [{
            type: HostBinding,
            args: ['class._disabled']
        }], checked: [{
            type: HostBinding,
            args: ['class._active']
        }], radio: [{
            type: ViewChild,
            args: [TuiRadioComponent]
        }], item: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiRadioBlockModule, { declarations: function () { return [TuiRadioBlockComponent]; }, imports: function () { return [FormsModule,
        TuiHoveredModule,
        TuiPressedModule,
        TuiRadioModule,
        TuiWrapperModule]; }, exports: function () { return [TuiRadioBlockComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiRadioBlockModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                    TuiHoveredModule,
                    TuiPressedModule,
                    TuiRadioModule,
                    TuiWrapperModule,
                ],
                declarations: [TuiRadioBlockComponent],
                exports: [TuiRadioBlockComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiRadioBlockComponent, TuiRadioBlockModule };

//# sourceMappingURL=taiga-ui-kit-components-radio-block.js.map